const log_managementRouter = [
  {
      path: "list-log_management",
      name: "log_management",
      component: () => import("@/views/admin/log_management"),
      default: true,
      meta: {
          model: "log_management",
          // requiresAuth: true,
      },
//   },
//   {
//       path: "list-log_management/add",
//       name: "addlog_management",
//       component: () => import("@/views/admin/log_management/function"),
//       default: true,
//       meta: {
//           model: "log_management",
//           // requiresAuth: true,
//       },
//   },
//   {
//       path: "list-log_management/view/:id",
//       name: "editlog_management",
//       component: () => import("@/views/admin/log_management/function"),
//       default: true,
//       meta: {
//           model: "log_management",
//           // requiresAuth: true,
//       },
  },
];
export default log_managementRouter;